import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import moment, { Moment } from "moment";
import { pdf } from "@react-pdf/renderer";
import { generateReportData } from "../../utils/pdf-report.utils.ts";
import { ActivityReport } from "./activity-report.tsx";
import usePricingManagamentAlertsStore from "../../../stores/pricing-management-alerts.store.ts";
import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import usePricingManagementStore from "../../../stores/pricing-management.store.ts";

export function GenerateReportButton() {
  const { savedDeals } = usePricingManagementStore();
  const { setSnackMessage } = usePricingManagamentAlertsStore();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [reportDateRange, setReportDateRange] = useState<[Moment, Moment]>([
    moment().subtract(1, "year"),
    moment(),
  ]);

  async function downloadReport() {
    if (reportDateRange[1].isBefore(reportDateRange[0])) {
      return setSnackMessage("The end date must be after the start date.");
    }

    setOpenDialog(false);
    const pdfData = generateReportData(savedDeals, reportDateRange);
    if (!pdfData.valid) return setSnackMessage(pdfData.error);

    try {
      const blob = await pdf(
        // @ts-ignore
        <ActivityReport {...pdfData.body} />
      ).toBlob();
      const pdfUrl = window.URL.createObjectURL(blob);
      const tempLink = document.createElement("a");
      tempLink.href = pdfUrl;
      tempLink.setAttribute(
        "download",
        `activity-report-${moment().format("MM-DD-YYYY-HH:mm:ss:SS")}.pdf`
      );
      tempLink.click();
      tempLink.remove();
    } catch (err) {
      console.log(err)
      setSnackMessage("There was an error generating your report.");
    }
  }

  return (
    <React.Fragment>
      <Button
        variant="contained" 
        sx={{ color: "white" }}
        color="primary"
        onClick={() => setOpenDialog(true)}
      >
        Generate Report
      </Button>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle>Generate Activity Report</DialogTitle>
  
        <DialogContent>
          <Stack direction="row" gap={1} py={2}>
            <DatePicker
              label="Start Bid Date"
              value={reportDateRange[0]}
              slotProps={{ textField: { sx: { width: '100%' }} }}
              onChange={(val) => {
                if (!val || !val.isValid) return;
                setReportDateRange([val, reportDateRange[1]]);
              }}
            />
            <DatePicker
              label="End Bid Date"
              format="MM/DD/YYYY"
              value={reportDateRange[1]}
              slotProps={{ textField: { sx: { width: '100%' }} }}
              onChange={(val) => {
                if (!val || !val.isValid) return;
                setReportDateRange([reportDateRange[0], val]);
              }}
            />
          </Stack>
        </DialogContent>
  
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="error">Cancel</Button>
          <Button onClick={downloadReport}>Generate</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
